import ParameterErrors from '../errors/ParameterErrors';
import ClickedOffManager from '../ui_core/ClickedOffManager';
import SubMenuHeaderNonReact from '../components/SubMenuHeaderNonReact';
import GenericWindow from '../window/GenericWindow';
import WindowEventNames from '../window/WindowEventNames';
import Windows from '../window/Windows';
import WindowType from '../enums/WindowType';
import PlotDetailedInformationSummary from './PlotDetailedInformationSummary';
import PlotDetailedInformationGallery from './PlotDetailedInformationGallery';
import PlotDetailedInformationDescription from './PlotDetailedInformationDescription';
import PlotDetailedInformationFloorPlans from './PlotDetailedInformationFloorPlans';
import PlotDetailedInformationVideo from './PlotDetailedInformationVideo';
import PlotDetailedInformationTour from './PlotDetailedInformationTour';
import HouseGridSelectorInfo from '../house_types_viewer/HouseGridSelectorInfo';
import IconButton from '../components/IconButtonNonReact';
import eventEnable from '../core/eventEnable';
import getAbsolute from '../ui_core/getAbsolute';
import UrlParameters from '../urls/UrlParameters';
import './PlotDetailedInformation.css';
import { faAngleLeft, faAngleRight} from '@fortawesome/free-solid-svg-icons'
const {throwNotProvided}=ParameterErrors;
export default class PlotDetailedInformation {
	constructor(props){
		const {parentElement, siteJsonUnitPlot, callbackDispose,
			addFavourite, removeFavourite, showStreetView,
			showImagesFullScreen, configuration, showPlot, showBrochureGenerationDialog,
			enterHouse, callbackPlotNumberChanged}=props;
		this._enterHouse = enterHouse;
		eventEnable(this);
		this._showPlot= showPlot;
		this._siteJsonUnitPlot = siteJsonUnitPlot;
		this._callbackDispose = callbackDispose;
		this._callbackShowStreetView= showStreetView;
		this._callbackShowImagesFullScreen = showImagesFullScreen;
		this._callbackPlotNumberChanged = callbackPlotNumberChanged;
		if(!parentElement)throwNotProvided('parentElement');
		this._parentElement = parentElement;
		this._currentPlotActiveHandle = null;
		this.show = this.show.bind(this);
		this.hide = this.hide.bind(this);
		this._setVisible = this._setVisible.bind(this);
		this.close = this.close.bind(this);
		this.dispose = this.dispose.bind(this);
		this._scrollToFloorPlans = this._scrollToFloorPlans.bind(this);
		this._scrollToGallery = this._scrollToGallery.bind(this);
		this._handleEnterHouse = this._handleEnterHouse.bind(this);
		this._scrollToElement = this._scrollToElement.bind(this);
		this.scrollToTop = this.scrollToTop.bind(this);
		this._onClose = this._onClose.bind(this);
		this._handleShowStreetView = this._handleShowStreetView.bind(this);
		this.scrollToSectionWithProportion = this.scrollToSectionWithProportion.bind(this);
		this.setSectionProportionRanges = this.setSectionProportionRanges.bind(this);
		this._dispatchScrolled = this._dispatchScrolled.bind(this);
		let title;
		const moreThanOnePlotInUnit = this._siteJsonUnitPlot.unit.plots.length>1;
		if(moreThanOnePlotInUnit){
			title = "More details";
		}
		else 
			title = "More details for plot "+siteJsonUnitPlot.number;
		this._window = new GenericWindow({tooltipMessage:title, name:title, minWidth:250, maxWidth:1700, minHeight:100, maxHeight:1000,
			defaultWidth:600, defaultHeight:600, defaultX:10, defaultY:10, minimized:false, maximized:false, minimizable:true,
			maximizable:true, closeable:true, minimizeOnClose:false, resizable:true, dragable:true, toggleMaximizeOnDoubleClick:false,
			type:WindowType.PLOT_DETAILED_INFORMATION
		});
		const resizeChildren = ()=>{
				this._houseGridSelectorInfo?.resized();
				if(this._tour)
					this._tour.element.style.height = (this._element.clientHeight+30)+'px';
		};
		this._window.addEventListener(WindowEventNames.RESIZED, resizeChildren);
		this._window.addEventListener(WindowEventNames.MAXIMIZED, resizeChildren);
		this._window.addEventListener(WindowEventNames.UNMAXIMIZED, resizeChildren);
		this._window.addEventListener(WindowEventNames.UNMINIMIZED, resizeChildren);
		if(moreThanOnePlotInUnit){
			this._createNextPreviousPlotButtons();
		}
		this._window.addEventListener(GenericWindow.EventNames.CLOSED, this._onClose);
		this._element = this._window.getElement();
		this._element.classList.add('plot-detailed-information');
		this._mainElement = this._window.getMainElement();
			
		this._scrollableElement = document.createElement('div');
		this._mainElement.appendChild(this._scrollableElement);
		this._scrollableElement.classList.add('scrollable');
		this._scrollableElement.addEventListener('scroll', this._dispatchScrolled);
		
		if(UrlParameters.salesforce){
			const houseType = siteJsonUnitPlot.houseType;
			console.log('siteJsonUnitPlot');
			console.log(siteJsonUnitPlot);
			this._houseGridSelectorInfo = new HouseGridSelectorInfo({getWindowElement:()=>this._element, configuration, showBrochureGenerationDialog});
			this._scrollableElement.appendChild(this._houseGridSelectorInfo.element);
			this._houseGridSelectorInfo.load(houseType);
		}
		else
		{
		
			this._summary = new PlotDetailedInformationSummary({siteJsonUnitPlot, addFavourite, 
				removeFavourite, showStreetView:this._handleShowStreetView, 
				scrollToFloorPlans:this._scrollToFloorPlans, 
				scrollToGallery:this._scrollToGallery,
				configuration, showBrochureGenerationDialog, enterHouse:this._handleEnterHouse});
			this._gallery = new PlotDetailedInformationGallery({
				siteJsonUnitPlot:siteJsonUnitPlot,
				showImagesFullScreen,
				configuration
			});
			this._floorPlans = new PlotDetailedInformationFloorPlans({
				siteJsonUnitPlot:siteJsonUnitPlot,
				showImagesFullScreen,
				configuration
			});
			this._description = new PlotDetailedInformationDescription({
				siteJsonUnitPlot:siteJsonUnitPlot
			});
			this._video = new PlotDetailedInformationVideo({
				siteJsonUnitPlot:siteJsonUnitPlot,
				configuration
			});
			this._tour = new PlotDetailedInformationTour({
				siteJsonUnitPlot:siteJsonUnitPlot,
				configuration
			});
			
			this._sections = [this._gallery, this._floorPlans, this._description, this._video, this._tour];
			this._sections.forEach(section=>
				this._scrollableElement.appendChild(section.element));	
			this._tour.addEventListener('loaded', this.setSectionProportionRanges);
			this._gallery.addEventListener('loaded', this.setSectionProportionRanges);
			this._floorPlans.addEventListener('loaded', this.setSectionProportionRanges);
			this._mainElement.insertBefore(this._summary.element, this._scrollableElement);
		
		
		
		
		//this._scrollableElement.addEventListener('touchmove', this._dispatchScrolled);
		}
		this._parentElement.appendChild(this._element);
		this.show();
		this.window.addEventListener(GenericWindow.EventNames.UNMINIMIZED, this.setSectionProportionRanges);
		this.window.addEventListener(GenericWindow.EventNames.FOCUSSED, this.setSectionProportionRanges);
		this.window.getElement().addEventListener('mouseenter', this.setSectionProportionRanges);
	}
	scrollToTop(){
		this._scrollableElement.scrollTop=0;
	}
	_handleEnterHouse(plot){
		this._enterHouse(plot);
		this.window.minimize();
	}
	_createNextPreviousPlotButtons(){
		const tabElement = this.window.getTabElement();
		const nextPreviousElement = document.createElement('div');
		nextPreviousElement.classList.add('next-previous');
		const setNewPlotFromIndex=(plot)=>{
			this._siteJsonUnitPlot =  plot;
			this._callbackPlotNumberChanged(this, this._siteJsonUnitPlot);
			this._setupSiteJsonUnitPlot();
		};
		const previous = (e)=>{
			const plots = this._siteJsonUnitPlot.unit.plots;
			const indexOfThisPlot = plots.indexOf(this._siteJsonUnitPlot);
			const newIndex = indexOfThisPlot<1?plots.length-1:indexOfThisPlot-1;
			setNewPlotFromIndex(plots[newIndex]);
		};
		const next = (e)=>{
			const plots = this._siteJsonUnitPlot.unit.plots;
			const indexOfThisPlot = plots.indexOf(this._siteJsonUnitPlot);
			const newIndex = indexOfThisPlot>=plots.length-1?0:indexOfThisPlot+1;
			setNewPlotFromIndex(plots[newIndex]);
		};
		const previousButton = new IconButton({faIcon:faAngleLeft, onClick:previous, className:'next'});
		const nextButton = new IconButton({faIcon:faAngleRight, onClick:next, className:'previous'});
		nextPreviousElement.appendChild(previousButton.element);
		const textElement = document.createElement('div');
		textElement.classList.add('text');
		textElement.innerHTML = 'Apartment Plot';
		nextPreviousElement.appendChild(textElement);
		nextPreviousElement.appendChild(nextButton.element);
		tabElement.insertBefore(nextPreviousElement, tabElement.childNodes[1]);
	}
	_setupSiteJsonUnitPlot(){
		this._summary.plot = this._siteJsonUnitPlot;
		this._gallery.plot = this._siteJsonUnitPlot;
		this._floorPlans.plot = this._siteJsonUnitPlot;
		this._description.plot = this._siteJsonUnitPlot;
		this._video.plot = this._siteJsonUnitPlot;
		this._tour.plot = this._siteJsonUnitPlot;
	}
	_handleShowStreetView(e){
		this.hide();
		this._callbackShowStreetView(e);
	}
	_scrollToFloorPlans(){
		this._scrollToElement(this._floorPlans.element);
	}
	_scrollToGallery(){
		this._scrollToElement(this._gallery.element);
	}
	_scrollToElement(element){
		this._scrollableElement.scrollTop  = element.getBoundingClientRect().top + this._scrollableElement.scrollTop - (this._scrollableElement.clientHeight/2);
	}
	get sectionTypeAndProportionScrolled(){
		const scrollableElementBounds = this._scrollableElement.getBoundingClientRect();
		const scrollableElementHeight = this._scrollableElement.scrollHeight;
		const currentProportion = (this._scrollableElement.scrollTop/scrollableElementHeight);
		let currentSection = null;
		let proportion = 0;
		for(const sectionProportionRange of this._sectionProportionRanges){
			if((sectionProportionRange.proportionFrom<=currentProportion)&&(sectionProportionRange.proportionTo>=currentProportion)){
				currentSection = sectionProportionRange.section;
				proportion = (currentProportion - sectionProportionRange.proportionFrom)
					/(sectionProportionRange.proportionTo - sectionProportionRange.proportionFrom);
				break;
			}
		}
		return currentSection?{
			sectionType:currentSection.sectionType,
			proportion:proportion
		}:null;
	}
	setSectionProportionRanges(){
		const scrollableElementBounds = this._scrollableElement.getBoundingClientRect();
		const scrollableElementHeight = this._scrollableElement.scrollHeight;
		if(this._sections){
			this._sectionProportionRanges = this._sections.map(section=>{
				const sectionElementBounds = section.element.getBoundingClientRect();
				const proportionFrom = (section.element.offsetTop)/scrollableElementHeight;
				const proportionTo = (section.element.offsetTop+section.element.offsetHeight )/scrollableElementHeight;
				return {proportionFrom, proportionTo, section};
			});
		}
	}
	scrollToSectionWithProportion(plotDetailedInformationSectionType, proportion){
		if(!this._sectionProportionRanges)this.setSectionProportionRanges();
		const sectionProportionRange = this._sectionProportionRanges.filter(sectionProportionRange=>sectionProportionRange.section.sectionType===plotDetailedInformationSectionType)[0];
		if(!sectionProportionRange)return;
		const proportionForStartSection = sectionProportionRange.proportionFrom;
		const proportionForProportionThroughSection = (sectionProportionRange.proportionTo - sectionProportionRange.proportionFrom)*proportion;
		const totalProportionToScrollTo = proportionForStartSection +proportionForProportionThroughSection;
		const pxToScrollTo = this._scrollableElement.scrollHeight*totalProportionToScrollTo;
		this._scrollableElement.scrollTop = pxToScrollTo;
	}
	get window(){
		return this._window;
	}
	get number(){
		return this._siteJsonUnitPlot.number;
	}
	show(){
		this._window.unminimize();
	}
	hide(){
		this._window.minimize();
	}
	_setVisible(value){
		if(value)
			this._element.classList.add('visible');
		else
			this._element.classList.remove('visible');
	}
	close(){
		this._window.close();
		this.dispose();	
	}
	_onClose(){
		this.dispose();
	}
	dispose(){
		this._callbackDispose(this);
	}
	bringIntoFocus(){
		this.show();
	}
	_dispatchScrolled(){
		this.dispatchEvent({type:'scrolled', plotDetailedInformation:this});
	}
}